import React from 'react'
import { Typography, Divider } from 'antd'
import { useTheme } from '../../contexts/ThemeContext'

const { Title, Paragraph, Text } = Typography

export default function PrivacyPolicy() {
  const { isDark } = useTheme()
  const bgColor = isDark ? '#141414' : '#ffffff'
  const textColor = isDark ? '#e8e8e8' : '#333'
  const mutedColor = isDark ? 'rgba(255,255,255,0.45)' : 'rgba(0,0,0,0.45)'

  return (
    <div style={{
      maxWidth: 800,
      margin: '0 auto',
      padding: '40px 24px',
      backgroundColor: bgColor,
      minHeight: '100vh',
      color: textColor,
    }}>
      <Title level={2} style={{ color: textColor, textAlign: 'center' }}>
        Política de Privacidade
      </Title>
      <Text style={{ display: 'block', textAlign: 'center', color: mutedColor, marginBottom: 32 }}>
        Última atualização: Maio de 2026
      </Text>

      <Divider style={{ borderColor: isDark ? '#333' : '#e8e8e8' }} />

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>1. Quem somos</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          O EtiquetandoAPP é uma plataforma B2B de operação logística e rastreabilidade. Esta Política
          de Privacidade descreve como tratamos dados pessoais relacionados ao uso da plataforma em
          conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>2. Dados que coletamos</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Tratamos apenas os dados necessários para autenticação, operação e segurança do ambiente, tais como:
        </Paragraph>
        <ul style={{ color: textColor, lineHeight: 2 }}>
          <li><strong>Dados de identificação profissional:</strong> nome, usuário, e-mail corporativo, empresa, perfil e código interno, quando aplicável</li>
          <li><strong>Credenciais de acesso:</strong> login e senha em formato protegido, fornecidos ou autorizados pela empresa contratante</li>
          <li><strong>Dados operacionais:</strong> informações de etiquetas, lotes, cargas, embarques e demais registros inseridos na rotina do cliente</li>
          <li><strong>Dados técnicos e de segurança:</strong> endereço IP, dispositivo, navegador, data, hora e logs de acesso</li>
          <li><strong>Cookies essenciais:</strong> utilizados para sessão, autenticação e preferências técnicas indispensáveis</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>3. Finalidade do tratamento</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Seus dados são utilizados para:
        </Paragraph>
        <ul style={{ color: textColor, lineHeight: 2 }}>
          <li>Disponibilizar o ambiente contratado e permitir a execução das rotinas operacionais</li>
          <li>Autenticar usuários autorizados pela empresa contratante e aplicar controle de acesso</li>
          <li>Registrar auditoria, monitoramento e evidências de segurança</li>
          <li>Atender demandas de suporte, continuidade do serviço e integrações técnicas</li>
          <li>Cumprir obrigações legais, regulatórias e contratuais</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>4. Base legal</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Tratamos seus dados com base nas seguintes hipóteses legais da LGPD:
        </Paragraph>
        <ul style={{ color: textColor, lineHeight: 2 }}>
          <li><strong>Execução de contrato (Art. 7º, V):</strong> para prestação dos serviços contratados pela empresa cliente</li>
          <li><strong>Legítimo interesse (Art. 7º, IX):</strong> para segurança, prevenção a fraude e melhoria do ambiente</li>
          <li><strong>Cumprimento de obrigação legal (Art. 7º, II):</strong> quando houver exigência normativa ou regulatória</li>
          <li><strong>Consentimento (Art. 7º, I):</strong> quando aplicável a cookies não essenciais ou tratamentos facultativos</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>5. Papel das partes e compartilhamento</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Em operações B2B, a empresa contratante normalmente atua como controladora dos dados pessoais
          e operacionais inseridos por seus usuários. A Etiquetando atua como operadora no tratamento
          necessário para execução da plataforma e pode atuar como controladora apenas em dados mínimos
          relacionados a faturamento, relacionamento comercial, segurança e cumprimento legal.
        </Paragraph>
        <ul style={{ color: textColor, lineHeight: 2 }}>
          <li><strong>Empresa contratante:</strong> para administração de usuários, perfis, auditoria e operação do negócio</li>
          <li><strong>Provedores de infraestrutura e tecnologia:</strong> hospedagem, banco de dados, monitoramento e envio de comunicações técnicas</li>
          <li><strong>Integrações autorizadas pelo cliente:</strong> sistemas corporativos, ERPs, WMSs ou bases internas do contratante</li>
          <li><strong>Autoridades competentes:</strong> quando houver determinação legal, regulatória ou judicial</li>
        </ul>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Não comercializamos dados pessoais e não realizamos cadastro público de usuários finais.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>6. Armazenamento e retenção</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Os dados são armazenados em ambientes com controles técnicos e administrativos adequados.
          Mantemos as informações pelo perãodo necessário para execução do contrato, atendimento a
          obrigações legais e suporte a auditorias. Os prazos de retenção podem variar conforme o contrato
          com a empresa cliente e as exigências normativas aplicáveis.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>7. Seus direitos (LGPD Art. 18)</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Você tem os direitos previstos na LGPD, incluindo confirmação da existência de tratamento,
          acesso aos dados pessoais e demais direitos aplicáveis. Em operações B2B, os dados cadastrais
          dos usuários são fornecidos e mantidos pela empresa contratante em seus próprios sistemas.
          Por isso, <strong>solicitações de correção, atualização ou exclusão cadastral devem ser direcionadas
            primeiramente à empresa contratante responsável pelo cadastro</strong>. A Etiquetando atua no tratamento
          necessário à prestação do serviço, conforme o papel de cada parte na relação contratual.
        </Paragraph>
        <ul style={{ color: textColor, lineHeight: 2 }}>
          <li>Confirmar a existência de tratamento de seus dados</li>
          <li>Acessar os dados pessoais tratados no contexto da plataforma</li>
          <li>Solicitar correção ou atualização cadastral por meio da empresa contratante</li>
          <li>Solicitar informações sobre compartilhamentos e tratamentos aplicáveis ao serviço</li>
          <li>Exercer os demais direitos previstos na LGPD pelos canais adequados, conforme o papel da contratante e da Etiquetando</li>
        </ul>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Quando o tratamento depender de consentimento, como no caso de cookies não essenciais, a revisão
          ou revogação poderá ser feita pelos mecanismos disponibilizados na própria plataforma.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>8. Cookies</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Utilizamos cookies essenciais para funcionamento da plataforma, como manutenção de sessão e
          autenticação. Cookies não essenciais, quando existentes, dependem de consentimento prévio e
          podem ser gerenciados pelo banner de cookies.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>9. Segurança</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Adotamos medidas técnicas e administrativas para proteger os dados tratados, incluindo
          proteção de credenciais, controle de acesso por perfil, trilhas de auditoria, criptografia
          e monitoramento compatível com a criticidade do ambiente.
        </Paragraph>
      </section>

      <section style={{ marginBottom: 24 }}>
        <Title level={4} style={{ color: textColor }}>10. Encarregado (DPO)</Title>
        <Paragraph style={{ color: textColor, lineHeight: 1.8 }}>
          Para exercer seus direitos ou esclarecer dúvidas sobre esta política, o usuário deve, sempre
          que aplicável, acionar primeiramente a empresa contratante responsável por seu cadastro. Também
          é possível entrar em contato conosco pelo canal informado em contrato ou pelo e-mail:
          dpo@arcosistemas.com.br
        </Paragraph>
      </section>

      <Divider style={{ borderColor: isDark ? '#333' : '#e8e8e8' }} />

      <Text style={{ display: 'block', textAlign: 'center', color: mutedColor, fontSize: 12 }}>
        EtiquetandoAPP - Todos os direitos reservados
      </Text>
    </div>
  )
}
